$(document).ready(function () {
  const base_w = 1024;
  bindSmoothScrollOnClick();
  filterFold();
  const featuredSlide = $(document).find('.featured-collection__container .featured-collection__content');
  var clone = $('.featured-collection__container .featured-collection__content .productgrid--item').clone();
  featuredSlide.append(clone);
  featuredSlide.slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    centerMode: true,
    variableWidth: true,
    infinite: true,
    dots: false,
    arrows: true
  });
  if ($(window).width() > 1280) {
    featuredSlide.slick("slickSetOption", "slidesToScroll", 4, true);
  } else if ($(window).width() > 768) {
    featuredSlide.slick("slickSetOption", "slidesToScroll", 2, true);
  } else {
    featuredSlide.slick("slickSetOption", "slidesToScroll", 1, true);
  }
  $('.box-slide-01 .slide-img').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1000,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.box-slide-01 .slide-thumb'
  });
  $('.box-slide-01 .slide-thumb').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 1000,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    asNavFor: '.box-slide-01 .slide-img'
  });
  if ($(window).width() > 768) {
    $('.box-slide-01 .slide-thumb').slick("slickSetOption", "slidesToShow", 4, true);
  } else {
    $('.box-slide-01 .slide-thumb').slick("slickSetOption", "slidesToShow", 3, true);
  }
  $('.product__price .money').each(function () {
    var htmlvar = $(this).text();
    htmlvar = htmlvar.replace("(税込)", "");
    $(this).attr('data-tax', htmlvar);
  });
  $('.box-option-01 .item-price').each(function () {
    var htmlvar = $(this).text();
    htmlvar = htmlvar.replace('(税込)', '<span class="tax">(税込)</span>');
    $(this).html(htmlvar);
  });
  $('.filter-form').each(function () {
    var fillter = getParam('filter.p.tag');
    if (!fillter) {
      fillter = getParam('filter.v.availability');
    }
    if (!fillter) {
      fillter = getParam('filter.v.price.lte');
    }
    if (!fillter) {
      fillter = getParam('filter.p.m.data.category');
    }
    if (!fillter) {
      fillter = getParam('filter.p.m.data.type');
    }
    if (!fillter) {
      fillter = getParam('filter.p.m.data.brand');
    }
    if (!fillter) {
      fillter = getParam('filter.p.m.data.filter_tag');
    }
    if (fillter) {
      $(this).addClass('is-open');
    }
  });
  isWrite();
  $(document).on("change input keyup", '.form-field-input', function (e) {
    isWrite();
  });
  optionNav();
  $('.box-option-01 .nav-list input').on('change', function () {
    optionNav();
  });

  //favorite
  $('.box-fav-01').each(function () {
    var pid = $(this).attr('data-id');
    var fav = $.cookie('fav');
    if (pid && fav) {
      var favid = '|' + pid + '|';
      if (fav.indexOf(favid) == -1) { //含まない
        $(this).removeClass('is-fav');
      } else { //含む
        $(this).addClass('is-fav');
      }
    }
  });
  $('.box-fav-01').on('click', function () {
    var pid = $(this).attr('data-id');
    if (pid) {
      var fav = $.cookie('fav');
      var favid = '|' + pid + '|';
      $(this).toggleClass('is-open');
      if (fav && fav.indexOf(favid) != -1) { //含む
        fav = fav.replace(favid, '')
        $.cookie('fav', fav);
        $(this).removeClass('is-fav');
      } else { //含まない
        $.cookie('fav', fav + favid);
        $(this).addClass('is-fav');
      }
    }
    //console.log('favID',fav);
  });

  //header
  $('.site-header-menu-toggle--button, .box-headernav-01 .nav-close').on('click', function () {
    $('.site-header').toggleClass('is-open');
  });
  $('.box-headernav-01 .level2').on('click', function () {
    $(this).toggleClass('is-open');
  });

  $('a[href^=http]').not('[href*="' + location.hostname + '"]').attr({
    target: "_blank"
  }).addClass("ex_link");
});

$(window).on("load resize scroll orientationchange", function () {
  var headerTop = $("header.site-header").outerHeight();
  if ($(this).scrollTop() >= headerTop) {
    $("header.site-header").addClass("is-fix");
  } else {
    $("header.site-header").removeClass("is-fix");
  }
});

var pos = 0;
$(window).on('scroll', function () {
  if ($(this).scrollTop() < pos) {
    $('header.site-header').addClass('is-up');
    $('header.site-header').removeClass('is-down');
  } else {
    $('header.site-header').addClass('is-down');
    $('header.site-header').removeClass('is-up');
  }
  pos = $(this).scrollTop();
});

$('.filter-form .filter-form-title').on('click', function () {
  $(this).closest('.filter-form').toggleClass('is-open');
});

$('.hotspot__tooltip').on('click', function () {
  var url = $(this).attr('href');
  window.location.href = url;
});

$('.utils-filter-button').on('click', function () {
  setTimeout(function () {
    filterFold();
  }, 500);
});

$(document).on("click", '.collection-filters__filter-list.is-fold', function (e) {
  $(this).removeClass('is-fold');
  console.log('bb');
});

function getParam(name, url) {
  if (!url) url = window.location.href;
  if (name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
}

function optionNav() {
  var option1 = $('.box-option-01 input[name="option1"]:checked').val();
  var option2 = $('.box-option-01 input[name="option2"]:checked').val();
  var option3 = $('.box-option-01 input[name="option3"]:checked').val();
  if (option1 && !option2 && !option3) {
    $('.box-option-01 .for-inner[data-option1="' + option1 + '"] input').prop('checked', true);
  }
  if (option1 && option2 && !option3) {
    $('.box-option-01 .for-inner[data-option1="' + option1 + '"][data-option2="' + option2 + '"] input').prop('checked', true);
  }
  if (option1 && option2 && option3) {
    $('.box-option-01 .for-inner[data-option1="' + option1 + '"][data-option2="' + option2 + '"][data-option3="' + option3 + '"] input').prop('checked', true);
  }
}

function isWrite() {
  $('.form-field-input').each(function () {
    var inputval = $(this).val();
    if (inputval) {
      $(this).closest('.form-field').addClass('is-write');
    } else {
      $(this).closest('.form-field').removeClass('is-write');
    }
  });
}

function bindSmoothScrollOnClick() {
  $('a[href^="#"]').click(function (e) {
    e.preventDefault();
    performSmoothScroll($(this), 400);
  });
}

function performSmoothScroll(obj, time) {
  const href = obj.attr("href");
  const target = $(href == "#" || href == "" ? "html" : href);
  if (target.length > 0) {
    const position = calculatePosition(target);
    $("body,html").stop().animate({
      scrollTop: position
    }, time, "swing");
    return false;
  }
}

function calculatePosition(target) {
  let position = target.offset().top - 10;
  position -= $("#header").outerHeight();
  return position;
}

function loadAnchor() {
  const hash = location.hash;
  const target = $(hash == "#" || hash == "" ? "html" : hash);
  if (target.length > 0) {
    $(window).scrollTop(0);
    const position = calculatePosition(target);
    $("body,html").stop().animate({
      scrollTop: position
    }, 1, "swing");
  }
}

function filterFold() {
  $('.collection-filters__filter-list').each(function () {
    let listHeight = $(this).outerHeight();
    if (listHeight) {
      $(this).css('max-height', listHeight);
    }
    if (listHeight > 100) {
      $(this).addClass('is-fold');
    }
  });
}
